import type { TranslationQuoteView } from '@/features/ai/useTranslationQuote'

/**
 * Какую цену вообще печатать. Отдельной функцией, а не тремя условиями в
 * рендере: обязательные поля зависят от тумблера, а правило одно и то же —
 * недоехавшая цена не печатается нулём, потому что ноль обещал бы бесплатный
 * прогон.
 */
export type Price =
  | { kind: 'full'; text: string; images: string; total: string }
  | { kind: 'text-only'; text: string }
  | null

export const priceToShow = ({
  hasUnits,
  translateImages,
  textCost,
  imagesCost,
  pendingTotalCost,
}: {
  hasUnits: boolean
  translateImages: boolean
  textCost?: string
  imagesCost?: string
  pendingTotalCost?: string
}): Price => {
  if (!hasUnits || textCost === undefined) return null
  if (!translateImages) return { kind: 'text-only', text: textCost }
  if (imagesCost === undefined || pendingTotalCost === undefined) return null
  return { kind: 'full', text: textCost, images: imagesCost, total: pendingTotalCost }
}

/** Сумма для кнопки запуска: с картинками — общая, без них — за текст; `null`, пока
 *  цена не доехала (ноль обещал бы бесплатный перевод). */
export const buttonPrice = (
  quote: TranslationQuoteView,
  translateImages: boolean,
): string | null => {
  const plan = priceToShow({
    hasUnits: (quote.pendingUnits ?? 0) > 0,
    translateImages,
    textCost: quote.textCost,
    imagesCost: quote.imagesCost,
    pendingTotalCost: quote.pendingTotalCost,
  })
  if (plan?.kind === 'full') return plan.total
  return plan?.kind === 'text-only' ? plan.text : null
}
